<template>
    <div v-if="form.status !== 1 && form.status !== 4 && form.typ === 4 && form.foO_DAT != null">
        <div class="detail-card yellow">
            <div class="card-header">
                <div class="title">核銷</div>
                <div class="actions">
                    <el-button v-if="isEditable" style="margin-left: 10px; color: #888" size="mini" @click="startFooChange">編輯 </el-button>
                </div>
            </div>
            <div class="card-body">
                <el-row :gutter="40" v-if="!isShowFooEditer">
                    <el-col :sm="14">
                        <spec-view>
                            <spec-item label="核銷日期">
                                {{ form.foO_DAT | dateFormater("YYYY-MM-dd") }}
                            </spec-item>
                            <spec-item v-if="form.cny !== 'TWD'" label="匯率">
                                {{ form.rat }}
                            </spec-item>
                        </spec-view>
                    </el-col>
                    <el-col :sm="10">
                        <spec-view>
                            <spec-item label="核銷人">
                                {{ form.foO_CRT_NAM }}
                            </spec-item>
                            <spec-item label="填寫日期">
                                {{ form.foO_CRT_DAT | dateFormater("YYYY-MM-dd") }}
                            </spec-item>
                        </spec-view>
                    </el-col>
                </el-row>
                <div v-if="isShowFooEditer">
                    <el-form :model="fooChangeForm" :rules="editRules" ref="fooChangeForm" label-position="left" label-width="100px" size="small">
                        <el-form-item prop="foO_DAT" label="核銷日期">
                            <el-date-picker v-model="fooChangeForm.foO_DAT" type="date" value-format="timestamp" :picker-options="expireTimeOption" size="small" />
                        </el-form-item>
                        <el-form-item v-if="form.cny !== 'TWD'" label="匯率">
                            <MoneyInput v-model="fooChangeForm.rat" :precision="4" style="width: 100px" />
                            <span style="margin-left: 10px"> 約當台幣：{{ Math.round(form.amt * fooChangeForm.rat) }} </span>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFooChange">
                                儲存
                            </el-button>
                            <el-button size="small" @click="cancelFooChange">
                                取消
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="detail-card" v-if="form.tranInvoiceList.length > 0">
            <div class="card-header">
                <div class="title" style="color:#AF9349">轉開發票</div>
            </div>
            <div class="card-body">
                <el-table
                    :data="form.tranInvoiceList"
                    style="width: 100%"
                    class="ah-el-data-table"
                    :row-class-name="getRowClass"
                    :summary-method="getTableSummaries"
                    show-summary
                    empty-text="沒有資料"
                >
                    <el-table-column prop="tioo" label="轉開發票單號" width="120">
                        <template slot-scope="scope">
                            <span :class="{ 'invoice-label': !disableReimbursementDialog }" @click="openInvoiceDetail(scope.row.tioo)">
                                {{ scope.row.tioo }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="摘要" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="開立日期" width="125" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="發票號碼" width="160">
                        <template slot-scope="scope">
                            <div>
                                <div style="font-size: 10pt">
                                    <span class="void-invoice" v-if="scope.row.foO_CNL">作廢</span>
                                    <ahReceiptNumber :v="scope.row.foo" />
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amt" label="開立金額" align="right" width="110">
                        <template slot-scope="scope">
                            <Money :v="scope.row.amt" />
                            <div v-if="scope.row.foO_DIS_AMT" class="amt-refund">
                                <span v-if="scope.row.foO_DIS === 2">退回 </span>
                                <span v-if="scope.row.foO_DIS === 1">折讓 </span>
                                <Money :v="scope.row.foO_DIS_AMT" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cny" label="幣別" width="75"></el-table-column>
                </el-table>
            </div>
        </div>
        <ReimbursementInvoiceDetailDialog
            v-if="!disableReimbursementDialog"
            disable-invoice-dialog
            :visible="reimbursementInvoiceDetailDialog.visible"
            :tioo="reimbursementInvoiceDetailDialog.sno"
            @close="onDetailDialogClose"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        disableReimbursementDialog: Boolean,
    },
    components: {
        ReimbursementInvoiceDetailDialog: () => import('@/components/dashboard/Finance/ReimbursementInvoice/ReimbursementInvoiceDetailDialog.vue'),
        ahReceiptNumber,
        SpecView,
        SpecItem,
    },
    data() {
        return {
            isShowFooEditer: false,
            invoiceSerialInputValidate: false,
            fooChangeForm: {
                foO_DAT: null,
                rat: null,
            },
            editRules: {
                foO_DAT: { required: true },
                rat: { required: true },
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
            reimbursementInvoiceDetailDialog: {
                visible: false,
                sno: false,
            },
        };
    },
    computed: {
        isEditable() {
            if (this.isAuthOne(['B02', 'B03']) && (this.form.status === 2 || this.form.status === 3) && !this.isShowFooEditer) {
                return true;
            }
            return false;
        },
        isShowDiscountButton() {
            if (!this.form) return false;
            if (this.isShowFooEditer) return false;
            if (this.form.foO_DIS_DAT === null) return true;
            return false;
        },
    },
    methods: {
        startFooChange() {
            this.fooChangeForm.foO_DAT = this.form.foO_DAT;
            this.fooChangeForm.rat = this.form.rat;
            this.isShowFooEditer = true;
        },
        cancelFooChange() {
            this.isShowFooEditer = false;
            this.fooChangeForm.foO_DAT = this.form.foO_DAT;
            this.fooChangeForm.rat = this.form.rat;
        },

        async submitFooChange() {
            try {
                await this.$api({
                    url: '/InvoiceManagemnetPage/UpdateInvoiceSimpleInfo',
                    method: 'post',
                    data: {
                        invoiceSno: this.form.sno,
                        rat: this.fooChangeForm.rat,
                        foo: null,
                        foO_DAT: this.fooChangeForm.foO_DAT,
                    },
                });

                this.$message.success('發票資訊已儲存。');
                this.$emit('reload');
                // this.reload();
            } finally {
                this.isShowFooEditer = false;
            }
        },

        getRowClass({ row }) {
            if (row.foO_CNL) return 'void-row';

            return '';
        },
        getTableSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            columns.forEach((column, index) => {
                if (column.property === 'amt') {
                    const SUM = _.chain(data)
                        .filter(['foO_CNL', 0])
                        .sumBy('amt');
                    sums[index] = Number(SUM).toLocaleString('en');
                } else if (column.property === 'cny') {
                    sums[index] = 'TWD';
                } else if (column.property === 'tioo') {
                    sums[index] = '開發票金額總計';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },

        openInvoiceDetail(sno) {
            if (this.disableReimbursementDialog) return;
            this.reimbursementInvoiceDetailDialog.sno = sno;
            this.reimbursementInvoiceDetailDialog.visible = true;
        },
        onDetailDialogClose() {
            this.reimbursementInvoiceDetailDialog.visible = false;
            this.reimbursementInvoiceDetailDialog.sno = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-label {
    text-decoration: underline;
    cursor: pointer;
}
.void-invoice {
    background-color: #909090;
    border-radius: 7px;
    background: #909090;
    padding: 3px 6px;
    color: #fff;
    margin-right: 5px;
}
.amt-refund {
    color: red;

    .label {
        display: inline-block;
        border: 1px solid red;
        border-radius: 5px;
        padding: 0px 10px;
        margin-right: 10px;
    }
}
</style>

<style lang="scss">
.void-row {
    opacity: 0.4;
}
</style>
